import { paramCleaner } from '@/helpers/formatters';
import { postRequest } from '@/api/request';
import { isEmpty } from 'lodash-es';

export const downloadFLSAReportCsv = async ({
  params = {}, selectedFilters, searchTerm, owned,
}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  const searchParams = new URLSearchParams();

  if (typeof sort !== 'undefined') searchParams.append('sort', sort);

  return postRequest({
    url: `/jobprofile/flsa-report/download-csv?${searchParams}`,
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
    isCsv: true,
    timeout: 60000,
  });
};

export const getFLSAReportTotals = async ({
  selectedFilters, searchTerm, params = {}, owned,
} = {}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  return postRequest({
    url: '/jobprofile/flsa-report/totals',
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
  });
};

export const getFLSAReportProfiles = async ({
  params = {}, selectedFilters, searchTerm, owned,
}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  const searchParams = new URLSearchParams();
  if (typeof sort !== 'undefined') searchParams.append('sort', sort);
  if (typeof page !== 'undefined') searchParams.append('page', page);

  const {
    items = [],
    filters = [],
    sorting = {},
    pagination = {},
    textFilter = {},
  } = await postRequest({
    url: `/jobprofile/flsa-report/profiles?${searchParams}`,
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
  });

  return {
    items,
    filters,
    sorting,
    pagination,
    textFilter,
  };
};
